import { render, staticRenderFns } from "./SavedChannel.vue?vue&type=template&id=15be3da3&scoped=true&"
import script from "./SavedChannel.vue?vue&type=script&lang=js&"
export * from "./SavedChannel.vue?vue&type=script&lang=js&"
import style0 from "./SavedChannel.vue?vue&type=style&index=0&id=15be3da3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be3da3",
  null
  
)

export default component.exports